import type { WebsitePageUpdatePayload } from '../../../types/websiteBuilder';

export interface PageDraft {
  metaTitle: string;
  metaDescription: string;
  jsonLd: string;
  html: string;
  css: string;
  componentConfig: Record<string, unknown>;
}

/** Only the fields the owner edited belong in a PATCH. */
export function pagePatch(draft: PageDraft, baseline: PageDraft, version: string): WebsitePageUpdatePayload {
  const patch: WebsitePageUpdatePayload = { base_updated_at: version };
  if (draft.metaTitle !== baseline.metaTitle) patch.meta_title = draft.metaTitle;
  if (draft.metaDescription !== baseline.metaDescription) patch.meta_description = draft.metaDescription;
  if (draft.html !== baseline.html) patch.html = draft.html;
  if (draft.css !== baseline.css) patch.css = draft.css;
  if (draft.jsonLd !== baseline.jsonLd) {
    try { patch.json_ld = draft.jsonLd.trim() ? JSON.parse(draft.jsonLd) : {}; }
    catch { throw new Error('Structured data must be valid JSON before saving.'); }
  }
  if (JSON.stringify(draft.componentConfig) !== JSON.stringify(baseline.componentConfig)) {
    patch.component_config = draft.componentConfig;
  }
  return patch;
}
